'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardFormTeamsCtrl', ['Department', 'dialog', 'forms', '$state', 'teams','items','toast','$translate', require('./dashboardFormTeamsCtrl')]);
app.config(['$stateProvider', require('./dashboardFormTeamsConfig')]);
